/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
class SlideshowClassicHotspot {
  OPEN_CLASS = 'slideshow-classic__hotspot--open';
  CLOSE_CLASS = 'slideshow-classic__hotspot--closed';

  constructor($el) {
    this.$hotspot = $el;
    this.$pin = $el.find('[data-slideshow-classic-pin]');
    this.isOpen = false;
  }

  open() {
    this.isOpen = true;
    this.$hotspot.addClass(this.OPEN_CLASS);
    this.$pin.attr('aria-expanded', 'true');
  }

  close() {
    this.isOpen = false;
    this.$hotspot.removeClass(this.OPEN_CLASS);
    this.$hotspot.addClass(this.CLOSE_CLASS);
    this.$pin.attr('aria-expanded', 'false');
    setTimeout(() => {
      this.$hotspot.removeClass(this.CLOSE_CLASS);
    }, 2000);
  }
}

window.PXUTheme.jsSlideshowClassic = {
	init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowClassic = $.extend(this, window.PXUTheme.getSectionData($section));
    this.$section = $section;
    // Enable debug logging for troubleshooting; toggleable globally
    window.PXUTheme = window.PXUTheme || {};
    window.PXUTheme.debugSlideshowClassic = true;
    const DEBUG = !!window.PXUTheme.debugSlideshowClassic;
    if (DEBUG) console.log('[SlideshowClassic] init section:', $section.attr('id') || $section.data('section-id'));

    // Selectors
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');
    const slideshowClassicController = this;

    const $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape
    });

    // Ensure axes are recalculated after images load inside Flickity (clones may be created)
    $slideshowClassicEl.on('imagesLoaded.flickity', function() {
      if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) console.log('[SlideshowClassic] imagesLoaded.flickity — recalculating axes');
      slideshowClassicController.hotspots = slideshowClassicController.collectHotspots($section);
      slideshowClassicController.bindHotspots($section);
      slideshowClassicController.updateHotspotAxes();
    });

    // After Flickity initializes (it may clone cells for wrapAround), collect hotspots
    this.hotspots = this.collectHotspots($section);
    if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) console.log('[SlideshowClassic] collected hotspots (post-init):', this.hotspots.length);
    this.bindHotspots($section);
    this.updateHotspotAxes();

    // Resize flickity when the slider is settled
    $slideshowClassicEl.on( 'settle.flickity', function() {
      if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) console.log('[SlideshowClassic] settle.flickity — re-collecting hotspots');
      // Re-collect and re-bind after settle because Flickity may create/remove clones
      slideshowClassicController.hotspots = slideshowClassicController.collectHotspots($section);
      if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) console.log('[SlideshowClassic] hotspots after settle:', slideshowClassicController.hotspots.length);
      slideshowClassicController.bindHotspots($section);
      $slideshowClassicEl.flickity('resize');
      slideshowClassicController.updateHotspotAxes();
    })

    this._resizeHandler = function() {
      slideshowClassicController.updateHotspotAxes();
    };

    $(window).on('resize', this._resizeHandler);

  },
  collectHotspots: function($section) {
    const arr = $section.find('[data-slideshow-classic-hotspot]').toArray().map((element) => new SlideshowClassicHotspot($(element)));
    if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) {
      console.log('[SlideshowClassic] collectHotspots -> found', arr.length);
      arr.forEach((h, i) => console.log('[SlideshowClassic] hotspot', i, h.$hotspot.attr('id')));
    }
    return arr;
  },
  bindHotspots: function($section) {
    this.hotspots.forEach((hotspot) => {
      if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) console.log('[SlideshowClassic] bindHotspots -> binding', hotspot.$hotspot.attr('id'));
      // remove previous handlers to avoid double-binding when re-binding after Flickity changes
      hotspot.$hotspot.off('focusout');
      hotspot.$pin.off('click');

      hotspot.$hotspot.on('focusout', (event) => {
        if (hotspot.$hotspot[0].contains(event.relatedTarget)) return;
        hotspot.close();
      });

      hotspot.$pin.on('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleHotspot(hotspot);
      });

      // Ensure tooltip anchor is clickable on touch devices (Flickity may intercept swipes)
      const $tooltipLink = hotspot.$hotspot.find('.slideshow-classic__tooltip-link-wrapper');
      if ($tooltipLink && $tooltipLink.length) {
        $tooltipLink.off('click.touch');
        $tooltipLink.on('click.touch', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const href = $(this).attr('href');
          if (href) {
            window.location.href = href;
          }
        });

        // Support touchend as some browsers may not fire click during swipe contexts
        $tooltipLink.off('touchend.force');
        $tooltipLink.on('touchend.force', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const href = $(this).attr('href');
          if (href) {
            window.location.href = href;
          }
        });
      }
    });
  },
  updateHotspotAxes: function() {
    this.hotspots.forEach((hotspot) => {
      let $interface = hotspot.$hotspot.closest('[data-slideshow-classic-hotspots]');
      let interfaceWidth = $interface.innerWidth();
      let interfaceHeight = $interface.innerHeight();

      // Fallback: use the media container height (image area) if hotspots wrapper has no height
      if ((!interfaceWidth || !interfaceHeight)) {
        const $media = hotspot.$hotspot.closest('.slideshow-classic__media');
        if ($media.length) {
          interfaceWidth = $media.innerWidth();
          interfaceHeight = $media.innerHeight();
          if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) console.log('[SlideshowClassic] fallback to .slideshow-classic__media size for', hotspot.$hotspot.attr('id'), interfaceWidth, interfaceHeight);
        }
      }

      // Second fallback: measure the first image inside the media
      if ((!interfaceWidth || !interfaceHeight)) {
        const $img = hotspot.$hotspot.closest('.slideshow-classic__media').find('img').first();
        if ($img && $img.length) {
          interfaceWidth = $img.width();
          interfaceHeight = $img.height();
          if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) console.log('[SlideshowClassic] fallback to image size for', hotspot.$hotspot.attr('id'), interfaceWidth, interfaceHeight);
        }
      }

      if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) {
        const baseDesktopH = hotspot.$hotspot[0].style.getPropertyValue('--slideshow-classic-horizontal-axis-base');
        const baseDesktopV = hotspot.$hotspot[0].style.getPropertyValue('--slideshow-classic-vertical-axis-base');
        const baseMobileH = hotspot.$hotspot[0].style.getPropertyValue('--slideshow-classic-horizontal-axis-base-mobile');
        const baseMobileV = hotspot.$hotspot[0].style.getPropertyValue('--slideshow-classic-vertical-axis-base-mobile');
        console.log('[SlideshowClassic] hotspot interface for', hotspot.$hotspot.attr('id'), 'width:', interfaceWidth, 'height:', interfaceHeight);
        console.log('[SlideshowClassic] raw vars', { baseDesktopH, baseDesktopV, baseMobileH, baseMobileV });
      }

      if (!interfaceWidth || !interfaceHeight) {
        // retry a few times in case DOM/images are still settling
        hotspot._axisRetries = hotspot._axisRetries || 0;
        if (hotspot._axisRetries < 5) {
          hotspot._axisRetries += 1;
          if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) console.log('[SlideshowClassic] scheduling axis retry', hotspot.$hotspot.attr('id'), hotspot._axisRetries);
          setTimeout(() => { this.updateHotspotAxes(); }, 150);
        } else {
          if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) console.warn('[SlideshowClassic] interface size remains zero after retries for', hotspot.$hotspot.attr('id'));
        }
        return;
      }

      const isMobile = window.matchMedia && window.matchMedia('(max-width: 798px)').matches;
      const hAxisPropMobile = '--slideshow-classic-horizontal-axis-base-mobile';
      const vAxisPropMobile = '--slideshow-classic-vertical-axis-base-mobile';
      const hAxisProp = isMobile ? hAxisPropMobile : '--slideshow-classic-horizontal-axis-base';
      const vAxisProp = isMobile ? vAxisPropMobile : '--slideshow-classic-vertical-axis-base';

      let hAxis = parseFloat(hotspot.$hotspot[0].style.getPropertyValue(hAxisProp));
      if (isNaN(hAxis)) {
        hAxis = parseFloat(hotspot.$hotspot[0].style.getPropertyValue('--slideshow-classic-horizontal-axis-base')) || 0;
      }

      let vAxis = parseFloat(hotspot.$hotspot[0].style.getPropertyValue(vAxisProp));
      if (isNaN(vAxis)) {
        vAxis = parseFloat(hotspot.$hotspot[0].style.getPropertyValue('--slideshow-classic-vertical-axis-base')) || 0;
      }
      const pinWidth = 30;
      const subAreaWidthFactor = (interfaceWidth - pinWidth) / interfaceWidth;
      const subAreaHeightFactor = (interfaceHeight - pinWidth) / interfaceHeight;


        // read base values for desktop and mobile (fallback mobile->desktop)
        const baseDesktopH = parseFloat(hotspot.$hotspot[0].style.getPropertyValue('--slideshow-classic-horizontal-axis-base')) || 0;
        const baseDesktopV = parseFloat(hotspot.$hotspot[0].style.getPropertyValue('--slideshow-classic-vertical-axis-base')) || 0;
        const baseMobileH = parseFloat(hotspot.$hotspot[0].style.getPropertyValue('--slideshow-classic-horizontal-axis-base-mobile'));
        const baseMobileV = parseFloat(hotspot.$hotspot[0].style.getPropertyValue('--slideshow-classic-vertical-axis-base-mobile'));

        const resolvedMobileH = !isNaN(baseMobileH) ? baseMobileH : baseDesktopH;
        const resolvedMobileV = !isNaN(baseMobileV) ? baseMobileV : baseDesktopV;

        const computedDesktopH = baseDesktopH * subAreaWidthFactor;
        const computedDesktopV = baseDesktopV * subAreaHeightFactor;
        const computedMobileH = resolvedMobileH * subAreaWidthFactor;
        const computedMobileV = resolvedMobileV * subAreaHeightFactor;

        // set both desktop and mobile computed values as CSS variables
        hotspot.$hotspot[0].style.setProperty('--slideshow-classic-horizontal-axis', computedDesktopH);
        hotspot.$hotspot[0].style.setProperty('--slideshow-classic-vertical-axis', computedDesktopV);
        hotspot.$hotspot[0].style.setProperty('--slideshow-classic-horizontal-axis-mobile', computedMobileH);
        hotspot.$hotspot[0].style.setProperty('--slideshow-classic-vertical-axis-mobile', computedMobileV);
        if (window.PXUTheme && window.PXUTheme.debugSlideshowClassic) {
          console.log('[SlideshowClassic] updated axes for', hotspot.$hotspot.attr('id'), 'desktopH:', computedDesktopH, 'desktopV:', computedDesktopV, 'mobileH:', computedMobileH, 'mobileV:', computedMobileV);
        }
    });
  },
  toggleHotspot: function(hotspot) {
    if (hotspot.isOpen) {
      hotspot.$pin.trigger('blur');
      hotspot.close();
    } else {
      this.closeAllHotspots();
      hotspot.open();
    }
  },
  closeAllHotspots: function() {
    this.hotspots.forEach((hotspot) => hotspot.close());
  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-slideshow-classic]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

    const $selectedHotspot = $('#shopify-section-' + blockId).find('[data-slideshow-classic-hotspot]').first();
    if ($selectedHotspot.length) {
      const hotspot = this.hotspots.find((item) => item.$hotspot[0] === $selectedHotspot[0]);
      if (hotspot) {
        this.closeAllHotspots();
        hotspot.open();
      }
    }

  },
	unload: function($section) {
		if (this._resizeHandler) {
			$(window).off('resize', this._resizeHandler);
			this._resizeHandler = null;
		}
	}
}

/******/ })()
;